import './vendor/jquery.mailcheck.min';
import $ from 'jquery';
import { checkIfEmailExists } from './email-validation';

$(function () {
  $('.email_suggestion').each(function () {
    var $input = $(this);
    var hint = `<span class="after inline-flex" style="display:none" id="email_hint">${$input.attr('data-text')} <button type="button" id="email_suggestion" class="btn btn--plain btn--primary btn--smaller self-center pa0 pl1" title="${$input.attr('data-title')}"></button>?</span>`;
    $(this).after(hint);

    $(this).on('change', function () {
      var domains = [
        'hotmail.com',
        'gmail.com',
        'aol.com',
        'gmx.de',
        'googlemail.com',
        'yahoo.com',
        'icloud.com',
      ];
      $(this).mailcheck(domains, {
        suggested: function (element, suggestion) {
          $('#email_suggestion').text(suggestion.full);
          $('#email_hint').show();
        },
        empty: function () {
          $('#email_hint').hide();
        },
      });
    });

    $('#email_suggestion').on('click', async function (e) {
      e.preventDefault();
      const suggestion = $(this).text();
      const accessTokenElement = document.querySelector(
        'meta[name="cobot:access-token"]',
      );
      $input.val(suggestion);
      if (accessTokenElement) {
        await checkIfEmailExists(suggestion, accessTokenElement);
      }
      $('#email_hint').hide();
    });
  });
});
